module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// F:/node/lex/aws-deploy/lex-chatbot/node_modules/babel-runtime/regenerator/index.js
// module id = ../../../node_modules/babel-runtime/regenerator/index.js
// module chunks = 0